import {
  GET_SUPPLIERS,
  GET_SUPPLIERS_SUCCESS,
  GET_SUPPLIERS_FAIL,
  DELETE_SUPPLIER,
  DELETE_SUPPLIER_SUCCESS,
  DELETE_SUPPLIER_FAIL,
  EDIT_SUPPLIER,
  EDIT_SUPPLIER_SUCCESS,
  EDIT_SUPPLIER_FAIL,
  EDIT_SUPPLIER_CLEAN,
  SAVE_SUPPLIER_PROFILE,
  SAVE_SUPPLIER_PROFILE_SUCCESS,
  SAVE_SUPPLIER_PROFILE_FAIL,
  GET_SUPPLIER_PROFILE,
  GET_FILE_REQUIREMENT_SUPPLIER,
  GET_FILE_REQUIREMENT_SUPPLIER_SUCCESS,
  GET_FILE_REQUIREMENT_SUPPLIER_FAIL,
  EXPORT_SUPPLIER,
  EXPORT_SUPPLIER_SUCCESS,
  EXPORT_SUPPLIER_FAIL,
  DATA_EXPORT_SUPPLIER_CLEAN
} from "./actionTypes"

export const getSuppliers = filter => ({
  type: GET_SUPPLIERS,
  payload: filter,
})

export const getSuppliersSuccess = supplier => ({
  type: GET_SUPPLIERS_SUCCESS,
  payload: supplier,
})

export const getSuppliersFail = error => ({
  type: GET_SUPPLIERS_FAIL,
  payload: error,
})

export const deleteSupplier = (supplier, status) => ({
  type: DELETE_SUPPLIER,
  payload: { supplier, status },
})

export const deleteSupplierSuccess = supplier => ({
  type: DELETE_SUPPLIER_SUCCESS,
  payload: supplier,
})

export const deleteSupplierFail = error => ({
  type: DELETE_SUPPLIER_FAIL,
  payload: error,
})
export const editLimitUser = supplier => ({
  type: EDIT_SUPPLIER,
  payload: supplier,
})
export const editSupplierSuccess = supplier => ({
  type: EDIT_SUPPLIER_SUCCESS,
  payload: supplier,
})

export const editSupplierFail = error => ({
  type: EDIT_SUPPLIER_FAIL,
  payload: error,
})

export const editSupplierClean = () => ({
  type: EDIT_SUPPLIER_CLEAN,
  payload: {},
})

export const saveSupplierProfile = data => ({
  type: SAVE_SUPPLIER_PROFILE,
  payload: data,
})

export const saveSupplierProfileSuccess = data => ({
  type: SAVE_SUPPLIER_PROFILE_SUCCESS,
  payload: data,
})

export const saveSupplierProfileFail = data => ({
  type: SAVE_SUPPLIER_PROFILE_FAIL,
  payload: data,
})

export const getSupplierProfile = data => ({
  type: GET_SUPPLIER_PROFILE,
  payload: data,
})

export const getFileRequirement = idSupplier => ({
  type: GET_FILE_REQUIREMENT_SUPPLIER,
  payload: idSupplier,
})

export const getFileRequirementSuccess = list => ({
  type: GET_FILE_REQUIREMENT_SUPPLIER_SUCCESS,
  payload: list,
})

export const getFileRequirementFail = error => ({
  type: GET_FILE_REQUIREMENT_SUPPLIER_FAIL,
  payload: error,
})

export const exportSupplier = idSupplier => ({
  type: EXPORT_SUPPLIER,
  payload: idSupplier,
})
export const exportSupplierSuccess = ls => ({
  type: EXPORT_SUPPLIER_SUCCESS,
  payload: ls,
})

export const exportSupplierFail = error => ({
  type: EXPORT_SUPPLIER_FAIL,
  payload: error,
})

export const dataExportSupplierClean = () => ({
  type: DATA_EXPORT_SUPPLIER_CLEAN,
  payload: {},
})